// frontend/src/components/TraderIdentity.js
//
// The block of text that says who is on the other side of the contract.
//
// Rendered in the Terms, in the Privacy Policy (where the same details identify
// the data controller) and on the Contact page. While the registration is still
// missing it prints the trading name and the contact details and nothing else —
// the fields it does not have are simply absent, never filled with a plausible
// stand-in, because a fabricated registered address published as fact is a
// worse problem than an incomplete one.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCompany } from '../utils/useCompany';
import theme from '../theme';

const LINK = { color: theme.gold };

export default function TraderIdentity({ style }) {
  const { t } = useTranslation();
  const c = useCompany();

  return (
    <p style={style}>
      <strong>{c.legalName || c.tradingName}</strong>
      {c.legalName && c.legalName !== c.tradingName && (
        <><br />{t('company.tradingAs', { name: c.tradingName })}</>
      )}
      {c.registrationNumber && (
        <><br />{t('company.regNumber', { value: c.registrationNumber })}</>
      )}
      {c.vatNumber && (
        <><br />{t('company.vatNumber', { value: c.vatNumber })}</>
      )}
      {c.address && <><br />{c.address}</>}
      {!c.address && <><br />{t('company.countryOnly')}</>}
      <br />
      {t('company.emailLabel')}: <a href={`mailto:${c.email}`} style={LINK}>{c.email}</a>
      {c.phone && (
        <><br />{t('company.phoneLabel')}: <a href={`tel:${c.phone.replace(/\s+/g, '')}`} style={LINK}>{c.phone}</a></>
      )}
    </p>
  );
}
